import { navLinks, feedCats } from "@/mocks/chigua";

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-primary-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
          <div>
            <a href="#top" className="inline-flex items-center gap-2">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent-400 text-lg text-primary-950">
                <i className="ri-water-flash-fill" aria-hidden="true"></i>
              </span>
              <span className="font-fun text-3xl text-background-50">看吃瓜</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-6 text-primary-100/80">
              全网热议事件一网打尽。我们聚焦热点爆料与爆款瓜，把来龙去脉捋清楚，让围观更省心、更清醒。
            </p>
            <div className="mt-5 flex items-center gap-2 text-xs text-primary-100/70">
              <span className="flex h-6 items-center rounded-full bg-primary-100/15 px-2.5 font-semibold">
                先求证 · 再发布
              </span>
              <span className="flex h-6 items-center rounded-full bg-primary-100/15 px-2.5 font-semibold">
                理性围观
              </span>
            </div>
          </div>

          <nav aria-label="站内导航">
            <h3 className="font-fun text-lg text-accent-300">快速导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {navLinks.map((l) => (
                <li key={l.id}>
                  <a href={`#${l.id}`} className="text-primary-100/85 transition-colors hover:text-background-50">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="频道导航">
            <h3 className="font-fun text-lg text-accent-300">内容频道</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {feedCats
                .filter((c) => c.key !== "all")
                .map((c) => (
                  <li key={c.key}>
                    <a href="#live" className="text-primary-100/85 transition-colors hover:text-background-50">
                      {c.label}
                    </a>
                  </li>
                ))}
            </ul>
          </nav>

          <div>
            <h3 className="font-fun text-lg text-accent-300">订阅与联系</h3>
            <p className="mt-4 text-sm text-primary-100/80">新瓜提醒 + 深度复盘推送</p>
            <a
              href="#subscribe"
              className="mt-3 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-400 px-5 py-2.5 text-sm font-bold text-primary-950 transition-colors hover:bg-accent-300"
            >
              <i className="ri-mail-add-line" aria-hidden="true"></i>订阅吃瓜快讯
            </a>
            <a
              href="mailto:hello@kanchigua.example"
              className="mt-4 block text-sm text-primary-100/85 transition-colors hover:text-background-50"
            >
              意见反馈：hello@kanchigua.example
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-100/20">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-6 text-xs text-primary-100/70 sm:flex-row md:px-6">
          <p>© 2026 看吃瓜 · 聚焦全网热议事件的资讯围观平台</p>
          <p className="text-center sm:text-right">
            内容以信源核实为准，理性围观，友善表达。本平台不构成任何倾向性立场。
          </p>
        </div>
      </div>
    </footer>
  );
}